{
  "appName": "21P-0969 Income and Asset Statement Form",
  "entryFile": "./app-entry.jsx",
  "entryName": "income-and-asset-statement",
  "rootUrl": "/supporting-forms-for-claims/submit-income-and-asset-statement-form-21p-0969",
  "productId": "83372f7f-9e10-4929-a230-7fe2967de75c"
}
